import { Component, ContentChildren, Input, OnInit, ViewEncapsulation, QueryList } from '@angular/core';
import { AD_SUPPORT, AtSupport } from '../directives/support.directive';

export type RadioTheme = 'primary' | 'secondary' | 'tertiary' | 'magenta' | 'orange' | 'purple' | 'red' | 'teal' | 'yellow' | 'gray';

@Component({
  selector: 'at-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  host: {
    'class': 'at-radio-button',
    '[class.at-radio-button-primary]': 'theme === "primary"',
    '[class.at-radio-button-secondary]': 'theme === "secondary"',
    '[class.at-radio-button-tertiary]': 'theme === "tertiary"',
    '[class.at-radio-button-magenta]': 'theme === "magenta"',
    '[class.at-radio-button-orange]': 'theme === "orange"',
    '[class.at-radio-button-purple]': 'theme === "purple"',
    '[class.at-radio-button-red]': 'theme === "red"',
    '[class.at-radio-button-teal]': 'theme === "teal"',
    '[class.at-radio-button-yellow]': 'theme === "yellow"',
    '[class.at-radio-button-gray]': 'theme === "gray"'
  },
  encapsulation: ViewEncapsulation.None
})
export class RadioButtonComponent implements OnInit {
  @ContentChildren(AD_SUPPORT, {descendants: true}) _supportChildren: QueryList<AtSupport>;

  @Input()
  get theme(): RadioTheme { return this._theme; }
  set theme(value: RadioTheme) {
    this._theme = value || 'primary';
  }
  _theme: RadioTheme;

  constructor() { }

  ngOnInit() {
  }

}
